import { API_BASE_URL } from './apiBaseUrl';

const COLORS = [
  '#A63D40',
  '#1D3557',
  '#2A9D8F',
  '#E76F51',
  '#3A0CA3',
  '#457B9D',
  '#6A994E',
  '#BC6C25',
];

function hashString(value) {
  let hash = 0;

  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }

  return Math.abs(hash);
}

function getInitials(seed) {
  const parts = seed.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return 'BM';
  }

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

export function getLocalAvatar(seed = 'Band Musician') {
  const safeSeed = String(seed || 'Band Musician');
  const hash = hashString(safeSeed);
  const bgColor = COLORS[hash % COLORS.length];
  const initials = getInitials(safeSeed);

  const svg = `
    <svg xmlns='http://www.w3.org/2000/svg' width='320' height='320' viewBox='0 0 320 320'>
      <rect width='320' height='320' fill='${bgColor}' />
      <circle cx='160' cy='120' r='56' fill='rgba(255,255,255,0.22)' />
      <rect x='66' y='192' width='188' height='92' rx='46' fill='rgba(255,255,255,0.2)' />
      <text
        x='160'
        y='175'
        text-anchor='middle'
        font-family='Verdana, Geneva, Tahoma, sans-serif'
        font-size='74'
        fill='#FFFFFF'
        font-weight='700'
      >${initials}</text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export function resolveAvatarUrl(imageUrl, seed, uploadedImageId) {
  const isLocalDataAvatar =
    typeof imageUrl === 'string' && imageUrl.startsWith('data:image/');
  const isRelativeUploadPath =
    typeof imageUrl === 'string' && imageUrl.startsWith('/uploads/image/');

  if (uploadedImageId) {
    return `${API_BASE_URL}/uploads/image/${uploadedImageId}`;
  }

  if (isRelativeUploadPath) {
    return `${API_BASE_URL}${imageUrl}`;
  }

  if (typeof imageUrl === 'string' && imageUrl.startsWith('http')) {
    try {
      const parsedUrl = new URL(imageUrl);

      if (parsedUrl.pathname.startsWith('/uploads/image/')) {
        return `${API_BASE_URL}${parsedUrl.pathname}`;
      }

      // Ignore temporary remote portrait URLs and use local avatars.
      if (parsedUrl.pathname.includes('/api/portraits/')) {
        return getLocalAvatar(seed);
      }
    } catch (error) {
      return imageUrl;
    }
  }

  if (!imageUrl) {
    return getLocalAvatar(seed);
  }

  if (isLocalDataAvatar) {
    return imageUrl;
  }

  return imageUrl;
}
